import React from 'react';
import { Col, Container, Row, Nav, NavItem, NavLink } from 'reactstrap';
import Logo from '../assets/img/pharm-icon-removebg-preview.png';
import payment from '../assets/img/payment.png';
function Footer() {
	return (
		<div className='footer'>
			<Container fluid className='px-5 py-4'>
				<Row>
					<Col lg='2' md='4' sm='6'>
						<img
							src={Logo}
							alt='Logo'
							height='100px'
							width='121px'
						/>
						<p className='mt-3'>
							1487 Rocky Horse Carrefour Arlington, TX 16819
						</p>
						<i className='fab fa-facebook-f text__primary'></i>
						<i className='fab fa-instagram ml-3 text__primary'></i>
						<i className='fab fa-youtube ml-3 text__primary'></i>
						<i className='fab fa-pinterest-p ml-3 text__primary'></i>
						<i className='fab fa-linkedin-in ml-3 text__primary'></i>
					</Col>
					<Col lg='4' sm='6'>
						<h4 className='need__help'>Need help</h4>
						<div className='d-flex contact__info'>
							<i className='fa fa-phone mt-2'></i>
							<h2 className='ml-3'>0020 - 500 - 000</h2>
						</div>
						<p className=' address'>
							Monday – Friday: 9:00-20:00 Saturday: 11:00 – 15:00
						</p>
						<hr />
						<div className='d-flex email__info'>
							<i className='fa fa-envelope mt-1'></i>
							<p className='ml-3'>info@plusukmeds.com</p>
						</div>
						<hr />
					</Col>
					<Col lg='2' sm='4'>
						<h4 className='footer__heading'>Information</h4>
						<Nav
							className='ml-auto d-flex font-sub-paragraph'
							vertical
						>
							<NavItem>
								<NavLink>About us </NavLink>
							</NavItem>
							<NavItem>
								<NavLink>Delivery Information </NavLink>
							</NavItem>
							<NavItem>
								<NavLink>Privacy Policy </NavLink>
							</NavItem>
							<NavItem>
								<NavLink>Sales </NavLink>
							</NavItem>
							<NavItem>
								<NavLink>Terms & Conditions </NavLink>
							</NavItem>
						</Nav>
					</Col>
					<Col lg='2' sm='4'>
						<h4 className='footer__heading'>Account</h4>
						<Nav
							className='ml-auto d-flex font-sub-paragraph'
							vertical
						>
							<NavItem>
								<NavLink>My Account</NavLink>
							</NavItem>
							<NavItem>
								<NavLink>My orders </NavLink>
							</NavItem>
							<NavItem>
								<NavLink>Returns</NavLink>
							</NavItem>
							<NavItem>
								<NavLink>Shipping </NavLink>
							</NavItem>
							<NavItem>
								<NavLink>Wishlist </NavLink>
							</NavItem>
						</Nav>
					</Col>
					<Col lg='2' sm='4'>
						<h4 className='footer__heading'>Store</h4>
						<Nav
							className='ml-auto d-flex font-sub-paragraph'
							vertical
						>
							<NavItem>
								<NavLink>Affiliate</NavLink>
							</NavItem>
							<NavItem>
								<NavLink>Bestsellers </NavLink>
							</NavItem>
							<NavItem>
								<NavLink>Discount</NavLink>
							</NavItem>
							<NavItem>
								<NavLink>Latest products </NavLink>
							</NavItem>
							<NavItem>
								<NavLink>Sale </NavLink>
							</NavItem>
						</Nav>
					</Col>
				</Row>
				<hr />
				<div className='text-right'>
					<img src={payment} alt='payment' className='img-fluid' />
				</div>
			</Container>
		</div>
	);
}

export default Footer;
